<script setup lang="ts">
import { NSplit } from 'naive-ui'
import { useAttrs } from 'vue'

const props = withDefaults(defineProps<{
  direction?: 'horizontal' | 'vertical'
  size?: number
  min?: number
  max?: number
  resizable?: boolean
  separator?: boolean
  onResize?: (size: number) => void
  onResizeEnd?: (size: number) => void
}>(), {
  direction: 'horizontal',
  size: 0.5,
  min: 0.1,
  max: 0.9,
  resizable: true,
  separator: true,
})

const emit = defineEmits<{
  'resize': [size: number]
  'resize-end': [size: number]
}>()

const attrs = useAttrs()

const onResize = (size: number) => {
  emit('resize', size)
}

const onResizeEnd = (size: number) => {
  emit('resize-end', size)
}
</script>

<template>
  <NSplit
    :direction="direction"
    :size="size"
    :min="min"
    :max="max"
    :resizable="resizable"
    :separator="separator"
    v-bind="attrs"
    @resize="onResize"
    @resize-end="onResizeEnd"
  >
    <slot />
  </NSplit>
</template>

<style scoped>
/* Custom styles can be added here if needed */
</style>
